import * as React from 'react';
import { KycData } from './Types.masters';
import { FormComponentProps } from 'antd/lib/form';
import { commonStyles } from 'src/Library/CommonStyles';
import { StylesProps } from 'src/Library/Types';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import withStyles from 'react-jss';

interface IProps extends StylesProps<ReturnType<typeof ViewKYCStyles>>, FormComponentProps {
  kycData: any [];
  onlyKYC?: boolean;
}

const ViewKYCStyles = (theme) => ({
  ...commonStyles(theme),
  title: {
    padding: '20px',
    marginBottom: '0px',
  },
  textStyle: {
    fontSize: '12px',
    color: '#333333'
  }
});

const ViewKYC = (props: IProps) => {
  const { 
    kycData,
    classes,
    onlyKYC,
  } = props;

  const footerKycCodes = ['DISCLAIMER', 'USER_NAME', 'DATE'];
  const footerKycData = kycData
    .filter((item) => footerKycCodes.includes(item.code))
    .reduce((obj, item) => {
      obj[item.code] = item;
      return obj;
    }, {});
  const primaryKycData = kycData.filter((item) => !footerKycCodes.includes(item.code));

  return <div style={{
    backgroundColor: '#FFFFFF',
    ...(!onlyKYC && {
      margin: '30px 20px',
    }),
  }}>
    {!onlyKYC && <h3 className={classes.title}>KYC Details</h3>}
    <div className={classes.flexColumn}>
      {primaryKycData.map((item) => {
        return <Row style={{ margin: '15px 0px' }}>
          <Col className={classes.textStyle}
            span={8}
            style={{ textAlign: 'right' }}
          >{item.name}:</Col>
          <Col className={classes.textStyle} span={12} style={{
            marginLeft: '25px',
            fontWeight: 600,
          }}>{item.code === 'ADDRESS_PROOF' ?
            <a href={item.value?.fileUrl} target="_blank">{item.value?.fileName}</a>
            : item.value}</Col>
        </Row>;
      })}
      <div style={{
        backgroundColor: '#F5EEE4',
        padding: '30px',
      }}>
        <div style={{
          fontWeight: 600,
          fontSize: '14px',
          color: '#333333',
          padding: '15px'
        }}>
          {footerKycData.DISCLAIMER?.name}
        </div>
        <div className={classes.flexRow} style={{
          justifyContent: 'space-between'
        }}>
          <div style={{
            marginLeft: '15px',
          }}>
            <span className={classes.textStyle}>Date</span>:&nbsp;
            <span className={classes.textStyle}
              style={{fontWeight: 600 }}
            >
              {footerKycData.DATE?.value ?? '-'}
            </span>
          </div>
          <div style={{
            marginRight: '45px'
          }}>
            <span className={classes.textStyle}>User Name</span>:&nbsp;
            <span className={classes.textStyle}
              style={{ fontWeight: 600 }}
            >
              {footerKycData.USER_NAME?.value ?? '-'}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>;
}

export default withStyles(ViewKYCStyles)(ViewKYC);